//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CopyRight from '@vip-activity/ui/components/CopyRight/CopyRight.vue';
import Pay from './Pay/Pay.vue';
import ShareComp from './Share/ShareWrapper.vue';
import OtherAct from './OtherAct/OtherAct.vue';
import CallAct from './CallAct/CallAct.vue';
import PropSelf from './PropSelf/PropSelf.vue';
import TickAct from './TickAct/TickAct.vue';
import Rank from './Rank/Rank.vue';
import Head from './Head/Head.vue';
import TickPay from './TickPay/TickPay.vue';
import Photo from './Photo/Photo.vue';
import RulePop from './RulePop/RulePopWrapper.vue';
import ReceivePop from './ReceivePop/ReceivePop.vue';
import TickPayPen from './TickPayPen/TickPayPen.vue';
import ZhiboPop from './ZhiboPop/ZhiboPop.vue';
import logicComp from './logic';
import RecallPop from './RecallPop/RecallPop.vue';
import BeiAn from './BeiAn/BeiAn.vue';
export default {
  components: {
    Pay: Pay,
    ShareComp: ShareComp,
    OtherAct: OtherAct,
    CallAct: CallAct,
    PropSelf: PropSelf,
    TickAct: TickAct,
    Rank: Rank,
    Head: Head,
    TickPay: TickPay,
    Photo: Photo,
    RulePop: RulePop,
    CopyRight: CopyRight,
    ReceivePop: ReceivePop,
    TickPayPen: TickPayPen,
    ZhiboPop: ZhiboPop,
    logicComp: logicComp,
    RecallPop: RecallPop,
    BeiAn: BeiAn
  },
  computed: {
    actList: function actList() {
      return window.setting.活动时刻.活动列表 || [];
    }
  },
  mounted: function mounted() {
    this.share.setShare(this.rootShareConfig);
  }
};